import { z } from 'zod';
import { playerTeamRefSchema } from './team.js';
export const playerEntitySchema = z.object({
    id: z.string().uuid(),
    fpl_id: z.number().int(),
    web_name: z.string(),
    element_type: z.number().int(),
    first_name: z.string().optional(),
    second_name: z.string().optional(),
    team: playerTeamRefSchema,
    now_cost: z.number().int().optional(),
    total_points: z.number().int().optional(),
    form: z.string().optional(),
    selected_by_percent: z.string().optional(),
    updated_at: z.string().optional(),
});
